
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/anchors/components/anchorVariables.scss.css.virtualfile';
        module.exports = {"anchorHandleWidth":"140px","anchorHandleHeight":"24px","anchorHandleMarginRight":"68px"};